import { Routes } from '@angular/router';
import { RoutesPath } from '@shared/constants';
import { authGuard, dashboardGuard, guestGuard } from '@shared/guards';
import { languageResolver, storesResolver, userDataResolver } from '@shared/resolvers';

export const APP_ROUTES: Routes = [
  {
    path: RoutesPath.LOGIN,
    canActivate: [guestGuard],
    resolve: {
      language: languageResolver,
      user: userDataResolver,
    },
    loadComponent: () => import('@pages/login/login-page').then((m) => m.LoginPage),
  },
  {
    path: RoutesPath.HOME,
    canActivate: [authGuard],
    resolve: {
      language: languageResolver,
      user: userDataResolver,
    },
    loadComponent: () => import('@pages/home/home-page').then((m) => m.HomePage),
    children: [
      {
        path: '',
        loadComponent: () => import('@pages/walkthrough/walkthrough-page').then((m) => m.WalkthroughPage),
      },
      {
        path: RoutesPath.DASHBOARD,
        canActivate: [dashboardGuard],
        children: [
          {
            path: RoutesPath.STORES,
            resolve: { stores: storesResolver },
            children: [
              {
                path: '',
                loadComponent: () => import('@pages/dashboard/pages/store-selection').then((m) => m.StoreSelectionPage),
              },
              {
                path: RoutesPath.STORE_ID,
                loadComponent: () => import('@pages/dashboard/dashboard-page').then((m) => m.DashboardPage),
                children: [
                  { path: '', redirectTo: RoutesPath.OVERVIEW, pathMatch: 'full' },
                  {
                    path: RoutesPath.OVERVIEW,
                    loadComponent: () => import('@pages/dashboard/pages/overview').then((m) => m.OverviewPage),
                  },
                  {
                    path: RoutesPath.VENDORS,
                    loadComponent: () => import('@pages/dashboard/pages/vendors').then((m) => m.VendorsPage),
                  },
                  {
                    path: RoutesPath.BILLING_HISTORY,
                    loadComponent: () =>
                      import('@pages/dashboard/pages/billing-history').then((m) => m.BillingHistoryPage),
                  },
                ],
              },
            ],
          },
          { path: '', redirectTo: RoutesPath.STORES, pathMatch: 'full' },
        ],
      },
    ],
  },
  {
    path: ':languageId',
    resolve: {
      language: languageResolver,
    },
    loadComponent: () => import('@pages/home/home-page').then((m) => m.HomePage),
    children: [
      {
        path: '',
        loadComponent: () => import('@pages/walkthrough/walkthrough-page').then((m) => m.WalkthroughPage),
      },
    ],
  },
  {
    path: '**',
    redirectTo: RoutesPath.HOME,
  },
];
